import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "transcript",
  class: "transcript"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranscriptBlock = _resolveComponent("TranscriptBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.transcriptBlocks, (item) => {
      return (_openBlock(), _createBlock(_component_TranscriptBlock, {
        ref_for: true,
        ref: "transcriptBlocks",
        key: item.id,
        token: $props.token,
        model: item.model,
        chunks: item.chunks,
        "right-to-left": item.rightToLeft
      }, null, 8, ["token", "model", "chunks", "right-to-left"]))
    }), 128))
  ], 512))
}